/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { apiGet } from "./Api/apiCall";
import { AvailableDocumentRecipient } from "../types/AvailableDocumentRecipient";
import { CaseOrganization } from "../types/CaseOrganization";
import { ProductUnion } from "../types/ProductUnion";

export const fetchAvailableDocumentRecipients = (product: ProductUnion): Promise<AvailableDocumentRecipient[]> =>
  apiGet(
    `lb/services/generate_case_file/available_recipients/${encodeURIComponent(product.productClassName)}/${product.id}`,
  );

export const getOrganizationRecipient = (product: ProductUnion, recipientType: string): CaseOrganization | null => {
  const match = /^processParticipantsOrganizations\.([0-9]+)$/.exec(recipientType);
  return match
    ? product.processParticipantsOrganizations?.find((entry: CaseOrganization) => String(entry.id) === match[1]) ?? null
    : null;
};
